import {Api} from "./Api";
import { apiUrl } from "../enviroments/enviroments.dev";
import { Asset } from "../models/Assets";

const targetAsset   = "/assets";
const targetBank    = "/banks";
const targetNetwork = "/assets/networks";

export class AssetsService {

    public static getAllAssets(id:number) {
        return Api.get(apiUrl(targetAsset+"/organization/"+id));
    }

    public static createAsset(payload:Asset, id:number) {
        return Api.post(apiUrl(targetAsset+"/organization/"+id), payload);
    }

    public static getAllBanks() {
        return Api.get(apiUrl(targetBank));
    }

    public static getInvesting() {
        return Api.getInvesting();
    }

    public static getAllNetworks() {
        return Api.get(apiUrl(targetNetwork));
    }
    
}
